import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the auth token from local storage
    const currentUser = localStorage.getItem('currentUser');
    let token = null;

    if (currentUser && currentUser !== 'null') {
      const user = JSON.parse(currentUser);
      token = user.jwt; // Adjust this based on your actual token property name
    }

    // Clone the request and add the authorization header if token exists
    // if (token) {
    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: `Bearer ${token}`
    //     }
    //   });
    // }

    if (token) {
      // Get existing params
      let params = new HttpParams({ fromString: request.params.toString() });

      // Add the jwt parameter
      params = params.set('jwt', token);

      // Clone the request with the new params
      request = request.clone({
        params: params
      });
    }

    // Pass the cloned request to the next handler
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 401 Unauthorized errors
        if (error.status === 401) {

          // Clear local storage and redirect to login page
          localStorage.setItem('currentUser', 'null');
          localStorage.setItem('currentPermissions', 'null');
          this.router.navigate(['/login']);
        }
        return throwError(error);
      })
    );
  }
}

